import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { swipeChain } from '../utils/hubs/registry';
import { historyStep, markArriving, neighbours } from '../utils/hubs/chain';

/**
 * The swipe chain as the current page sees it (utils/hubs/chain.js): the
 * person's chain, where this page stands in it, and go('next' | 'prev'),
 * which the page swipe (components/Layout.js) and the pager
 * (components/hubs/HubPager.js) both call, so they move the history alike.
 * go answers whether it moved.
 */
export default function useHubChain() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const chain = useMemo(() => swipeChain(user), [user]);
  const { index, prev, next } = neighbours(location.pathname, chain);

  const go = useCallback((direction) => {
    const step = historyStep(direction, location, chain);
    if (!step) return false;
    markArriving(step.stop);
    if (step.back) navigate(-1);
    else navigate(step.to, { state: step.state });
    return true;
  }, [location, chain, navigate]);

  return { chain, index, prev, next, go };
}
